// create react FC component 
import { Link } from 'gatsby'
import React, { FC, useRef, useState } from 'react'
import { Button } from '../../components/UI'
import { StyledTextInput } from '../../components/UI/TextInput/styled'
import { StyledErrorMessage } from '../ContactPanel/styled'
import { StyledEmailInput, StyledEmailTextInput } from './styled'
import emailValidator from 'email-validator'
import posthog from 'posthog-js'
import axios from 'axios'
import styled from 'styled-components'
import useEventTracking from '../../lib/hooks/tracking'
import { getEnvironment } from '../../lib/utils/getEnviroment'


const StyledSuccessMessage = styled.p`
    font-size: 0.8rem;
    font-weight: 600;
    margin-top: 0.6rem;
    font-style: italic;
`

export const forbiddenDomains = [
    'gmail',
    'aol',
    'yahoo',
    'hotmail',
    'outlook',
    '163',
    'icloud',
    'protonmail',
    'seznam',
    'orange',
    'qq',
    'drmail',
    'ymail',
    'teml',
    'gmx',
    't-online',
    'live',
    'libero',
    'comcast',
    'naver',
    'yopmail',
    'googlemail',
    'wanadoo',
    'tiscali',
    'yandex'
];

export const EmailSubmit: FC<{ productCode: string, placeholder?: string, ctaLabel?: string }> = ({ productCode, placeholder, ctaLabel }) => {
    const emailRef = useRef(null);
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState('')
    const trackEvent = useEventTracking()

    const containsForbiddenDomain = email => {
        const domain = email.split('@')[1]
        const domainCheck = forbiddenDomains.some(forbiddenDomain => domain.includes(forbiddenDomain))
        domainCheck && posthog.capture('validation_triggered', { domain: domain })
        return domainCheck
    }


    const handleEmailChange = event => {
        if (loading) return;

        const inputValue = emailRef.current.value
        setEmail(inputValue)

        if (inputValue && (!emailValidator.validate(inputValue) || containsForbiddenDomain(inputValue))) {
            setEmailError(
                `Please enter your business email address. This form does not accept addresses from ${inputValue.split('@')[1]
                }.`,
            )
        } else {
            setEmailError('')
        }
    }


    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const submitEmail = async () => {
        setLoading(true)
        setSuccess(false)

        // TODO: fix later lambda returning 500 error on production
        // const environment = getEnvironment()
        // const lambdaURL = environment === 'production' ? 'https://api-gateway.pdf-tools.com' : 'https://api-gateway.pdf-tools-staging.com'

        try {
            // const response = await axios.post(`${lambdaURL}/hubspot-contact`, { email });
            const response = await axios.post(`${'https://api-gateway.pdf-tools-staging.com'}/hubspot-contact`, { email });

            setSuccess(true)
            trackEvent('product_kit_downloaded', { variant: 'require-email-for-download', product_name: productCode, });
        }
        catch (error) {
            setEmailError('An error occurred. Please try again.')
        }
        finally {
            setLoading(false)
        }
    }


    return (
        <div style={{ minWidth: '410px' }}>
            <StyledEmailInput>
                <StyledEmailTextInput
                    ref={emailRef}
                    name="email"
                    type="email"
                    placeholder={placeholder?.trim() ? placeholder : 'Your work email'}
                    required
                    onChange={handleEmailChange}
                />
                <Button
                    $variant="primary"
                    disabled={!!emailError || !email}
                    onClick={submitEmail}
                >
                    {ctaLabel || 'Submit'}
                </Button>
            </StyledEmailInput>
            {success && <StyledSuccessMessage>{`Success! 🎉 You'll receive an email shortly.`}</StyledSuccessMessage>}
            {emailError && <StyledErrorMessage>{emailError}</StyledErrorMessage>}
        </div>
    )
}

export default EmailSubmit
